import React, { useContext, useState } from 'react';
import { Col, Row } from 'antd';
import {
  CardsContainer,
  ContentContainer,
  ErrorMessage,
  HomeContainer,
  RowContainer,
  Tab,
  TabContainer,
} from './Home.style';
import Loader from './Loader';
import SummaryCard from './SummaryCard';
import { useGetFullAnnotationSetsQuery } from '../../redux/slices/icardio';
import { IAnnotationSet } from 'models/icardio';
import { UserContext } from '../../services/contexts';

const Home = () => {
  const {
    data: fullStudyAnnotationSets,
    isError,
    refetch,
  } = useGetFullAnnotationSetsQuery({ paginate: false }) as {
    data: IAnnotationSet[];
    isError: boolean;
    refetch: () => void;
  };
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState<'myJobs' | 'allJobs'>('myJobs');

  const myAnnotationSets = fullStudyAnnotationSets?.filter(
    annotationSet => annotationSet?.userEmail === user?.email
  );

  const LoadingCards = () => {
    return (
      <Row gutter={[16, 16]} justify={'start'} align="top" style={{ width: '100%' }}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Col xs={24} sm={24} md={12} lg={8} xl={6} key={index}>
            <Loader />
          </Col>
        ))}
      </Row>
    );
  };

  const LoadError = () => (
    <ErrorMessage>
      Could not load jobs.{' '}
      <button type="button" onClick={refetch}>
        Retry
      </button>
    </ErrorMessage>
  );

  const renderCards = (Cards: () => React.ReactElement) => {
    if (fullStudyAnnotationSets) return <Cards />;
    return isError ? <LoadError /> : <LoadingCards />;
  };

  const MyAnnotationSetCards = () => {
    return (
      <Row gutter={[16, 16]} justify={'start'} align="top" style={{ width: '100%' }}>
        {myAnnotationSets?.map(annotationSet => (
          <Col xs={24} sm={24} md={12} lg={8} xl={6} key={`annotation-${annotationSet?.uuid}`}>
            <SummaryCard annotationSet={annotationSet} key={annotationSet?.uuid} />
          </Col>
        ))}
      </Row>
    );
  };

  const AllAnnotationSetCards = () => {
    return (
      <Row gutter={[16, 16]} justify={'start'} align="top" style={{ width: '100%' }}>
        {fullStudyAnnotationSets?.map(annotationSet => (
          <Col xs={24} sm={24} md={12} lg={8} xl={6} key={`annotation-${annotationSet?.uuid}`}>
            <SummaryCard annotationSet={annotationSet} key={annotationSet?.uuid} />
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <HomeContainer>
      <ContentContainer>
        <TabContainer>
          <Tab isActive={activeTab === 'myJobs'} onClick={() => setActiveTab('myJobs')}>
            My Open Jobs
          </Tab>
          <Tab isActive={activeTab === 'allJobs'} onClick={() => setActiveTab('allJobs')}>
            All Open Jobs
          </Tab>
        </TabContainer>
        <RowContainer>
          <CardsContainer isActive={activeTab === 'myJobs'}>
            {renderCards(MyAnnotationSetCards)}
          </CardsContainer>
          <CardsContainer isActive={activeTab === 'allJobs'}>
            {renderCards(AllAnnotationSetCards)}
          </CardsContainer>
        </RowContainer>
      </ContentContainer>
    </HomeContainer>
  );
};

export default Home;
